// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

export const categoryAPI = {
  // GET /api/budget/categories/?type=EXPENSE|INCOME|SAVING|TRANSFER&active=true|false
  list: ({ type, active, ...rest } = {}) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    if (active !== undefined) params.set('active', active);
    Object.entries(rest).forEach(([k, v]) => v != null && params.set(k, v));
    return api.get(`/api/budget/categories/?${params.toString()}`);
  },

  // POST /api/budget/categories/
  create: (category) => api.post('/api/budget/categories/', category),

  // GET /api/budget/categories/<id>/
  detail: (id) => api.get(`/api/budget/categories/${id}/`),

  // PATCH /api/budget/categories/<id>/
  update: (id, data) => api.patch(`/api/budget/categories/${id}/`, data),

  // DELETE /api/budget/categories/<id>/ (soft-delete by default)
  delete: (id, hard = false) => {
    const url = hard
      ? `/api/budget/categories/${id}/?hard=true`
      : `/api/budget/categories/${id}/`;
    return api.delete(url);
  },

  // Nested subcategories
  // POST /api/budget/categories/<id>/subcategories/
  addSubcategory: (categoryId, subcategory) =>
    api.post(`/api/budget/categories/${categoryId}/subcategories/`, subcategory),

  // GET /api/budget/categories/<id>/subcategories/
  getSubcategories: (categoryId) =>
    api.get(`/api/budget/categories/${categoryId}/subcategories/`),
};

export default categoryAPI;
